var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppScreen',{staticClass:"ending-view",attrs:{"scrollable":false}},[_c('Enzo',_vm._b({ref:"enzo",attrs:{"buttons":[{ text: _vm.button_text, action: _vm.next }]}},'Enzo',_vm.$attrs,false))],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d8fae7e","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-svg-inline-loader/dist/index.min.js??ref--6!./src/components/views/EnzoFiring.vue
// module id = null
// module chunks = 